import { render, staticRenderFns } from "./nutritionLibrarySet.vue?vue&type=template&id=2044c7f8&scoped=true&"
import script from "./nutritionLibrarySet.vue?vue&type=script&lang=js&"
export * from "./nutritionLibrarySet.vue?vue&type=script&lang=js&"
import style0 from "./nutritionLibrarySet.vue?vue&type=style&index=0&id=2044c7f8&prod&lang=scss&scoped=true&"
import style1 from "./nutritionLibrarySet.vue?vue&type=style&index=1&id=2044c7f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2044c7f8",
  null
  
)

export default component.exports